import * as PIXI from 'pixi.js';
import PianoUtil from '@/util/piano-util';

export class GridBackground extends PIXI.Sprite {
    constructor({
        boundaries, 
        keyWidth,
        PIANO_WIDTH, 
        CHART_HEIGHT,
        BACKGROUND_COLOR_SEQUENCE, 
        BORDER = 1,
    } = {}) {
        super(PIXI.Texture.WHITE);
        console.log('grid boundaries', boundaries);
        this.anchor.set(0.5, 0.5);
        const graphics = new PIXI.Graphics();
        graphics.width = PIANO_WIDTH;
        graphics.height = CHART_HEIGHT;

        graphics.opacity = 0.4;
        // graphics.tint = 0x00FFFF;
        
        let x = -PIANO_WIDTH / 2;;
        graphics.alpha = 0.8;
        graphics.beginFill(0xFF33FF);
        graphics.drawRect(x, 0, PIANO_WIDTH, CHART_HEIGHT);
        graphics.endFill();
        const { min, max } = boundaries;
        const WHITE_KEYS = PianoUtil.whiteKeysBetween(min, max) + 1;
        console.log('grid white keys', WHITE_KEYS);
        for (let i = 0; i < WHITE_KEYS; i++) {
            graphics.beginFill(BACKGROUND_COLOR_SEQUENCE[(i) % 14]);
            const y = 0, width = keyWidth, height = CHART_HEIGHT;
            graphics.drawRect(x, y, width, height);
            console.log('grid draw rect', x,y,width, height)
            graphics.endFill();
            x += (keyWidth + BORDER);
        }
        return graphics;
    }
}